<template>
  <div class="anchor">
    <div class="front">
      <slot name="front">
      </slot>
    </div>
    <div class="back">
      <slot name="back">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card'
}
</script>

<style lang="less" scoped>
  .anchor {
    position: relative;
  }

  .front {
    position: absolute;
    top: 0;
    bottom: 0;
    transition: transform 600ms linear;
    backface-visibility: hidden;
    transform: rotateY(0deg);
  }

  .back {
    position: absolute;
    top: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 300ms steps(1, end), transform 600ms linear;
    transform: rotateY(180deg);
    backface-visibility: hidden;
  }

  .anchor:hover {
    .back {
      opacity: 1;
      transform: rotateY(0deg);
    }

    .front {
      transform: rotateY(180deg);
    }
  }
</style>
